import Vue from 'vue'
import VueSanitize from 'vue-sanitize'

const defaultOptions = {
	allowedTags: ['i'],
}

Vue.use(VueSanitize, defaultOptions)
